module.exports = __webpack_public_path__ + "static/media/valor3_12.57b9004d.png";